import LocationDetailTemplate from 'src/components/atomic/template/Service/LocationDetail'
import { useEffect } from 'react'
import useLocationEventBus from 'src/hooks/useEventBus/useLocationEventBus'
import useMediaQueryHook from 'src/hooks/useMediaQuery.hook'
import { useNavigate } from 'react-router-dom'
import { useAppDispatch } from 'src/hooks/redux/useAppDispatch'
import { resetSelectPin } from 'src/store/Reducer/page/locationPageSlice'
import { useLockBodyScrollHook } from 'src/hooks/useLockBodyScroll.hook'

const LocationDetail = () => {
  const navigate = useNavigate()
  const { currentMedia } = useMediaQueryHook()

  const dispatch = useAppDispatch()

  useLocationEventBus()
  useLockBodyScrollHook(true)

  useEffect(() => {
    currentMedia === 'pc' && navigate('/location')
  }, [navigate, currentMedia])

  useEffect(() => {
    return () => {
      dispatch(resetSelectPin())
    }
  }, [dispatch])

  return <LocationDetailTemplate />
}
export default LocationDetail
